






























import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
  name: 'KeywordGrowthCampaignLayout',

  middleware: [
    'errorRouteGuard',
    'authGuard',
    'hubspot',
    'hotjar',
    'accountSetupGuard'
  ],

  computed: {
    ...mapState('user', ['overrideMobileWarning'])
  }
});
